import { FC } from 'react';
import { FieldError } from 'react-hook-form';

import { JaNeiVetIkke } from '../../../../../utils/registerEnums';

import { EnumRadioButton } from './enumRadioButton';
import { EnumRadioGroup } from './enumRadioGroup';

interface Props {
  onChange: (year: JaNeiVetIkke) => void;
  error?: FieldError;
  value?: JaNeiVetIkke;
  i18nPrefix: string;
}

export const ServiceRadio: FC<Props> = ({ onChange, error, value, i18nPrefix }) => (
  <EnumRadioGroup
    error={error}
    value={value}
    labelKey={`${i18nPrefix}.label`}
    helperTextKey={`${i18nPrefix}.information`}
    onChange={(val) => onChange(val as JaNeiVetIkke)}
  >
    <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Ja} />
    <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.Nei} />
    <EnumRadioButton i18nPrefix="register" value={JaNeiVetIkke.VetIkke} />
  </EnumRadioGroup>
);
